<script>
import Cookies from 'js-cookie'
import { cannotAccessList } from '@/assets/cannotAccessList'

export default {
  name: 'TokenMixin',
  setup() {
    return {
      cookiesName: 'CORPPLUS_CMS_LID',
      langStorageName: 'CORPPLUS_CMS_LANG',
    }
  },
  methods: {
    getCurrentUserData() {
      const data = Cookies.get(this.cookiesName)

      if (data !== undefined && data !== null && data !== '') {
        return JSON.parse(Cookies.get(this.cookiesName))
      }

      return {}
    },
    /**
     * @param {Object} data - { id: -1, user_type: '', username: '' }
     */
    setUserData(data) {
      const userData = this.getCurrentUserData()
      if (this.$validate.DataValid(userData)) {
        Cookies.remove(this.cookiesName)
      }

      const isDev = (window.location.hostname).includes('localhost') || (window.location.hostname).includes('innpressionhost') || (window.location.hostname).includes('uat');
      const expired = new Date()
      expired.setMonth(expired.getMonth() + 1) // expires after 1 month
      Cookies.set(this.cookiesName, JSON.stringify(data), {
        path: '/',
        expires: expired,
        sameSite: 'strict',
        secure: isDev ? false : true,
      })
    },
    getUserType() {
      const userData = this.getCurrentUserData()
      return userData.user_type
    },
    removeUserCookies() {
      const userData = this.getCurrentUserData()
      if (this.$validate.DataValid(userData)) {
        Cookies.remove(this.cookiesName)
      }
    },
    isUserLogin() {
      const userData = this.getCurrentUserData()
      return userData && this.$validate.DataValid(userData.id)
    },
    checkUserData() {
      let resultType = false
      const isLogin = this.isUserLogin()
      if (isLogin) {
        resultType = true
      }

      if (!resultType) {
        this.forceLogout()
      } else {
        const userType = this.getUserType()
        const linkName = this.$route.name
        if (
          linkName &&
          this.$validate.DataValid(cannotAccessList[linkName]) &&
          cannotAccessList[linkName].includes(userType)
        ) {
          resultType = false
          this.$store.dispatch('setInitLoading', false)
        }
      }

      return resultType
    },

    async forceLogout(alert = true) {
      this.$store.dispatch('setInitLoading', true)
      this.removeUserCookies()
      if (alert === true) {
        this.$store.dispatch('toggleSnack', {
          message: 'tokenExpired',
          redirect: 'Login',
        })
      } else {
        this.$router.replace({ name: 'Login' })
        this.$store.dispatch('setInitLoading', false)
      }
    },

    getLangStorageName() {
      return this.langStorageName
    },
  },
}
</script>
